/**
 * HealthScreen.jsx
 * Health Connect integration screen
 */
import React from 'react';
import { CheckCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const HealthScreen = () => {
  const { t } = useTranslation();
  return (
  <div className="p-4 space-y-4">
    <h1 className="text-white text-xl font-bold pt-2">{t('health.title')}</h1>

    {/* Connection Status */}
    <div className="bg-gradient-to-br from-green-500/20 to-emerald-500/20 rounded-2xl p-5 border border-green-500/30">
      <div className="flex items-center gap-4">
        <div className="w-14 h-14 bg-yellow-500/20 rounded-xl flex items-center justify-center">
          <CheckCircle className="w-7 h-7 text-yellow-500" />
        </div>
        <div>
          <p className="text-yellow-400 font-semibold">{t('health.connected')}</p>
          <p className="text-zinc-400 text-sm">{t('health.source')}</p>
        </div>
      </div>
      <button className="w-full mt-4 py-2 bg-white/10 rounded-lg text-zinc-300 text-sm">
        {t('health.sync_now')}
      </button>
    </div>

    {/* Health Data Grid */}
    <div className="grid grid-cols-2 gap-3">
      {[
        { icon: '👟', label: t('health.steps'), value: '8.432', color: 'text-orange-400' },
        { icon: '🔥', label: t('health.calories'), value: '486 kcal', color: 'text-red-400' },
        { icon: '⚖️', label: t('health.weight'), value: '75.2 kg', color: 'text-yellow-400' },
        { icon: '❤️', label: t('health.heart_rate'), value: '72 bpm', color: 'text-pink-400' },
        { icon: '🌙', label: t('health.sleep'), value: '7h 23min', color: 'text-indigo-400' },
        { icon: '💧', label: t('health.body_fat'), value: '18.5%', color: 'text-blue-400' },
      ].map(item => (
        <div key={item.label} className="bg-zinc-800/50 rounded-xl p-4">
          <span className="text-2xl">{item.icon}</span>
          <p className={`text-lg font-bold mt-2 ${item.color}`}>{item.value}</p>
          <p className="text-zinc-500 text-[10px]">{item.label}</p>
        </div>
      ))}
    </div>

    {/* Sync Settings */}
    <div className="bg-zinc-800/50 rounded-2xl p-4">
      <h2 className="text-white font-medium text-sm mb-3">{t('health.sync_settings')}</h2>
      {[t('health.steps'), t('health.calories'), t('health.weight'), t('health.sleep')].map(item => (
        <div key={item} className="flex items-center justify-between py-2 border-b border-zinc-700/50 last:border-0">
          <span className="text-zinc-300 text-xs">{item}</span>
          <div className="w-10 h-6 bg-yellow-500 rounded-full relative">
            <div className="absolute right-1 top-1 w-4 h-4 bg-white rounded-full" />
          </div>
        </div>
      ))}
    </div>
  </div>
  );
};

export default HealthScreen;
